import { getPriorityColor, getStatusColor } from "./status-helpers";
import type { ProcessedTicketData } from "./ticket-types";

export function getTicketStatusInfo(status: string) {
  return {
    color: getStatusColor(status),
    displayText: status.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()),
  };
}

export function getTicketPriorityInfo(priority: string) {
  return {
    color: getPriorityColor(priority),
    displayText: priority.charAt(0).toUpperCase() + priority.slice(1),
  };
}

export function validateTicketData(ticket: Partial<{ title?: string; description?: string; contact_id?: string; status?: string; priority?: string }>): string[] {
  const errors: string[] = [];

  if (!ticket.title?.trim()) {
    errors.push("Title is required");
  }

  if (!ticket.description?.trim()) {
    errors.push("Description is required");
  }

  if (!ticket.contact_id) {
    errors.push("Contact is required");
  }

  if (!ticket.status) {
    errors.push("Status is required");
  }

  if (!ticket.priority) {
    errors.push("Priority is required");
  }

  return errors;
}

export function filterTicketsByStatus(
  tickets: ProcessedTicketData[],
  status: string
): ProcessedTicketData[] {
  if (!status) return tickets;

  const statusArray = status.includes(",") ? status.split(",") : [status];
  return tickets.filter((ticket) => statusArray.includes(ticket.status));
}

export function filterTicketsByPriority(
  tickets: ProcessedTicketData[],
  priority: string
): ProcessedTicketData[] {
  if (!priority) return tickets;

  const priorityArray = priority.includes(",") ? priority.split(",") : [priority];
  return tickets.filter((ticket) => priorityArray.includes(ticket.priority));
}

export function filterTicketsByAssignedUser(
  tickets: ProcessedTicketData[],
  assignedTo: string
): ProcessedTicketData[] {
  if (!assignedTo) return tickets;

  return tickets.filter((ticket) => ticket.assigned_to === assignedTo);
}

export function searchTickets(
  tickets: ProcessedTicketData[],
  searchTerm: string
): ProcessedTicketData[] {
  if (!searchTerm) return tickets;

  const term = searchTerm.toLowerCase();
  return tickets.filter(
    (ticket) =>
      ticket.title.toLowerCase().includes(term) ||
      ticket.description?.toLowerCase().includes(term) ||
      ticket.formatted_ticket_number?.toLowerCase().includes(term) ||
      ticket.client_name.toLowerCase().includes(term) ||
      ticket.assigned_to_name.toLowerCase().includes(term)
  );
}
